module.exports = {
  "id": "animate",
  "color": "purple",
  "title": "animate",
  "icon": "toss",
  "category": "style",
  "info": [
    {
      "text": "Make a piece bob up and down and rock back and forth",
      "image": "provision/glitches/animate/animate.gif"
    }
  ],
  "searchTags": ["bob","motion","move", "gyrate"],
  "exposedVariables": [
    {
      "spriteName": "$glitch_target",
      "variableName": "up/down amount",
      "tooltip":"Set the amount the piece will move up and down",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "50",
        "step": "1"
      },
      "value": "5"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "up/down speed",
      "tooltip":"Set the speed the piece will move up and down",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "50",
        "step": "1"
      },
      "value": "5"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "rotation amount",
      "tooltip":"Set the amount the piece will rotate",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "100",
        "step": "1"
      },
      "value": "10"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "rotation speed",
      "tooltip":"Set the speed the piece will rotate",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "50",
        "step": "1"
      },
      "value": "10"
    }
  ],
  "codeImage": "provision/glitches/animate/animate.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/animate/animate.svg"
};